<script>
	import { Router, Route, Link } from "svelte-routing";
	import { Styles,
		Icon,
		Button,
		Alert,
		Card, CardBody,
    CardFooter,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle,
		Tooltip } from 'sveltestrap';
	import { api_url } from "../ConfigService.js";
	import MenuItem from "../components/menuItem.svelte";
	import Loading from "../components/Loading.svelte";
	import Photo from "../pages/Photo.svelte";
	import Cart from "../pages/Cart.svelte";
  import Article from "../components/Article.svelte";
	import ShareDialog from "../components/shareDialog.svelte";

	export let code="";
	export let data;
	export let url="";
	export let addToCartCount=0;
	export let success=false;
	export let share=false;

	async function login() {
		const res = await fetch($api_url+'', {
			method: 'POST',
			body: JSON.stringify({
        code: code
			})
		})
    data = await res.json();
	}

	async function logout() {
		const res = await fetch($api_url+'?logout=true')
    data = await res.json();
		return false;
	}

	function redirectToMain() {
		location.href="/";
		return "";
	}

	function shareDialog() {
		share=true;
	}

	function countOfProductInCart(countOfProduct, cartCount) {
		if(cartCount!=0 && cartCount != null && cartCount != "NaN") {
			return " ("+cartCount+")";
		}
		else if(!(typeof countOfProduct == "undefined" || countOfProduct == null) && Array.isArray(countOfProduct)) {
			if(countOfProduct.length>0 && !success) {
				addToCartCount=countOfProduct.length;
				return " ("+countOfProduct.length+")";
			}
		}
		return "";
	}
</script>
{#await data}
	<Loading />
{:then data}
{#if data.logged}

<Card style="width:90%;margin:auto;">
	<Router url="{url}">
		<CardHeader>
		  {#if data.config.share}
				<div class="buttons">
					<span class="button" on:click="{()=>shareDialog()}" id="shareBtn"><Icon name="share-fill" /></span>
					<Tooltip target="shareBtn" placement="bottom">Sdílet galerii</Tooltip>
					&nbsp;
				</div>
			{/if}
			<CardTitle>{data.school.nazev}</CardTitle>
  	</CardHeader>
		<CardBody>
			<Route path="/">
					<div class="navLink">
						<MenuItem to="cart/" icon="cart-fill">Nákupní košík{countOfProductInCart(data.cart, addToCartCount)}</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
						<span on:click="{()=>logout()}"><MenuItem to="#" icon="x-circle">Odhlásit se</MenuItem></span>
					</div>
					<CardText>
						{#if data.text && data.text.length>0}
							{#if data.text[0].data.text}
								<p>{@html data.text[0].data.text}</p>
							{/if}
						{/if}
						{@html data.school.uvodni_info}
						{#if data.uzaverka}
							<br /><br />
							<Alert color="info">
								<h6 class="alert-heading text-center">Nejbližší uzávěrka objednávek: {data.uzaverka}</h6>
							</Alert>
						{/if}
					</CardText>
					<br>
					<Card style="max-width:400px;margin:auto;" color="light">
						<CardHeader>
							<CardTitle>Vyberte album:</CardTitle>
						</CardHeader>
						<CardBody style="text-align:center">
							{#each data.album as al}
								<div class="classButton"><Link to="album/{al.id}/{al.kod}"><Button color="primary" size="lg">{al.nazev}</Button></Link></div>
							{/each}
						</CardBody>
					</Card>
			</Route>
			<Route path="key/:key" let:params>
				<Loading />
				{redirectToMain()}
			</Route>
			<Route path="album/:id" let:params>
				<div class="navLink">
					<MenuItem to="/" icon="house-door-fill">Úvodní nabídka</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<MenuItem to="cart/" icon="cart-fill">Nákupní košík{countOfProductInCart(data.cart, addToCartCount)}</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<span on:click="{()=>logout()}"><MenuItem to="#" icon="x-circle">Odhlásit se</MenuItem></span>
				</div><br />
				<Photo id={params.id} key="" bind:addToCartCount />
			</Route>
			<Route path="article/:id" let:params>
				<div class="navLink">
					<MenuItem to="/" icon="house-door-fill">Úvodní nabídka</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<MenuItem to="cart/" icon="cart-fill">Nákupní košík{countOfProductInCart(data.cart, addToCartCount)}</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<span on:click="{()=>logout()}"><MenuItem to="#" icon="x-circle">Odhlásit se</MenuItem></span>
				</div><br />
				{#if data.text && params.id}
					<Article title={data.text[params.id].data.title} text={data.text[params.id].data.text} />
				{/if}
			</Route>
			<Route path="album/:id/:key" let:params>
				<div class="navLink">
					<MenuItem to="/" icon="house-door-fill">Úvodní nabídka</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<MenuItem to="cart/" icon="cart-fill">Nákupní košík{countOfProductInCart(data.cart, addToCartCount)}</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<span on:click="{()=>logout()}"><MenuItem to="#" icon="x-circle">Odhlásit se</MenuItem></span>
				</div><br />
				<Photo id={params.id} key={params.key} bind:addToCartCount />
			</Route>
			<Route path="cart/:status" let:params>
				<div class="navLink">
					<MenuItem to="/" icon="house-door-fill">Úvodní nabídka</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<span on:click="{()=>logout()}"><MenuItem to="#" icon="x-circle">Odhlásit se</MenuItem></span>
				</div>
				<Cart bind:addToCartCount status={params.status} />
			</Route>
			<Route path="cart/">
				<div class="navLink">
					<MenuItem to="/" icon="house-door-fill">Úvodní nabídka</MenuItem>&nbsp;&nbsp;|&nbsp;&nbsp;
					<span on:click="{()=>logout()}"><MenuItem to="#" icon="x-circle">Odhlásit se</MenuItem></span>
				</div>
				<Cart bind:addToCartCount />
			</Route>
	 </CardBody>
	 {#if data.footer && data.footer.length>0}
	 	{#if data.footer[0].data.text}
		 <CardFooter>
		 	{@html data.footer[0].data.text}
			<br>
			{#if data.text.gdpr}
				<Link to="/article/gdpr">{data.text.gdpr.title}</Link>&nbsp;&nbsp;|&nbsp;&nbsp;
			{/if}
			{#if data.text.termsAndConditions}
				<Link to="/article/termsAndConditions">{data.text.termsAndConditions.title}</Link>&nbsp;&nbsp;|&nbsp;&nbsp;
			{/if}
			{#if data.text.contact}
				<Link to="/article/contact">{data.text.contact.title}</Link>
			{/if}
			{#if data.text.help}
				<Link to="/article/help">{data.text.help.title}</Link>
			{/if}
		 </CardFooter>
		{/if}
	{/if}
	<br>
	</Router>
</Card>
{/if}
{/await}
<ShareDialog bind:data bind:open={share} />

<style>
	.classButton { margin-bottom:20px; }
	.navLink {text-align: right;}
	.navLink:hover, .navLink a:hover {text-decoration: none;}
	.navLink i { padding-right:10px; }
	.buttons { float:right; text-align:right; font-size:25px; }
	.button { border:1px solid rgba(0,0,0,.125); border-radius: calc(.25rem - 1px); padding:5px; cursor: pointer; }
</style>
